import { useRestPostQuery } from 'utils/hooks/api';
import { TriggeredMessagesRequest, TriggeredMessagesResponse } from '../types';

const CAMPAIGNS_TRIGGERED_SEND_LOG_URL = '/triggered/triggeredMessages.json';

export const useSentMessagesLogs = (
  requestParams: TriggeredMessagesRequest,
  { enabled }: { enabled: boolean },
) => {
  const { data, refetch, isLoading, isError, isSuccess, error } = useRestPostQuery<
    TriggeredMessagesResponse,
    TriggeredMessagesRequest
  >(CAMPAIGNS_TRIGGERED_SEND_LOG_URL, requestParams, { enabled });

  return { data, refetch, isLoading, isError, isSuccess, error };
};
